(function () {
  'use strict';
  if (window.__gggStorefrontPolish) return;
  window.__gggStorefrontPolish = true;

  // Work only on customer-facing text. Never alter URLs, source code, or form values.
  var excluded = 'script,style,noscript,template,textarea,input,[contenteditable]';
  var copyAttributes = ['alt','title','aria-label','placeholder'];
  function cleanText(text) { return text.replace(/[ \t]*\u2014[ \t]*/g, ' '); }
  function cleanTextNode(node) {
    if (node.nodeValue.indexOf('\u2014') === -1 || !node.parentElement || node.parentElement.closest(excluded)) return;
    node.nodeValue = cleanText(node.nodeValue);
  }
  function cleanAttributes(element) {
    if (element.matches(excluded)) return;
    copyAttributes.forEach(function (name) {
      var value = element.getAttribute(name);
      if (value && value.indexOf('\u2014') !== -1) element.setAttribute(name, cleanText(value));
    });
  }
  function cleanSubtree(root) {
    if (root.nodeType === 3) { cleanTextNode(root); return; }
    if (root.nodeType !== 1 || root.matches(excluded)) return;
    cleanAttributes(root);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeType === 1 && node.matches(excluded)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === 3) cleanTextNode(node); else cleanAttributes(node);
    }
  }

  function syncDeck(card) {
    var root = card.closest('.product-template') || document;
    var selected = Array.from(root.querySelectorAll('input:checked,select')).map(function (el) { return (el.value || '').trim().toLowerCase(); });
    var edition = selected.indexOf('shadow edition') !== -1 ? 'shadow' : selected.indexOf('original edition') !== -1 ? 'original' : '';
    if (!edition) return;
    var id = card.getAttribute('data-' + edition + '-variant-id');
    if (!id) return;
    var label = 'Terror Tarot Deck · ' + (edition === 'shadow' ? 'Shadow Edition' : 'Original Edition');
    var url = new URL(card.getAttribute('data-base-href'), window.location.origin);
    url.searchParams.set('variant', id);
    var href = url.pathname + url.search;
    if (card.getAttribute('href') !== href) card.setAttribute('href', href);
    var img = card.querySelector('img'), src = card.getAttribute('data-' + edition + '-src');
    if (img && src) { if (img.getAttribute('src') !== src) img.setAttribute('src',src); img.alt = label; }
    var title = card.querySelector('[data-ggg-deck-title]'), price = card.querySelector('[data-ggg-deck-price]');
    if (title && title.textContent !== label) title.textContent = label;
    var money = card.getAttribute('data-' + edition + '-price');
    if (price && money && price.textContent !== money) price.textContent = money;
  }
  function syncDecks() { document.querySelectorAll('[data-ggg-deck]').forEach(syncDeck); }
  document.addEventListener('change', function (event) {
    if (event.target.matches('.product-template input,.product-template select')) queueMicrotask(syncDecks);
  });
  document.addEventListener('shopify:section:load', syncDecks);
  syncDecks();

  // Request only products, with the same server-side sort, including legacy drawers.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="q"]')) return;
    var action = new URL(form.action, window.location.origin);
    if (!/\/search\/?$/.test(action.pathname) || action.origin !== window.location.origin) return;
    [['type', 'product'], ['sort_by', 'price-descending']].forEach(function (entry) {
      var inputs = form.querySelectorAll('[name="' + entry[0] + '"]');
      var input = inputs[0];
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = entry[0]; form.appendChild(input); }
      input.value = entry[1];
      for (var i = 1; i < inputs.length; i++) inputs[i].remove();
    });
  }, true);

  cleanSubtree(document.documentElement);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'characterData') cleanTextNode(record.target);
      else if (record.type === 'attributes') cleanAttributes(record.target);
      else record.addedNodes.forEach(cleanSubtree);
    });
  }).observe(document.documentElement, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:copyAttributes });
})();
